import { Component, OnInit, Input, Output, EventEmitter, TemplateRef, ViewChildren, SimpleChanges} from '@angular/core';

import { UtilService } from 'src/app/modules/shared/services/util.service';
import { CouponsService } from 'src/app/modules/retailer/services/coupons.service';

@Component({
  selector: 'app-manage-category',
  templateUrl: './manage-category.component.html',
  styleUrls: ['./manage-category.component.scss']
})
export class ManageCategoryComponent implements OnInit {

  @Input() module: string; // (CPG/RETAILER/ADMIN)
  @Output() actions = new EventEmitter(); // Actions from component

  public loginData: any;

  public categories: any = [];
  public currentAction: string;

  public categoryName!: string;

  constructor(
    private _utilService: UtilService,
    private _couponsService: CouponsService
  ) { }

  ngOnInit(): void {
    this.getStorageData();
  }

  async getStorageData() {
    if(this.module == 'RETAILER') {
      this.loginData = await this._utilService.getStorageData('R_LOGIN');
    } else if(this.module == 'ADMIN') {
      this.loginData = await this._utilService.getStorageData('A_LOGIN');
    }
  
    this.getCategories();
  }

  // Get categories
  getCategories() {
    this.categories = [];
    this.currentAction = 'getCategories';

    this._couponsService.getCategories(this.loginData.token, this.loginData.user_details.provider_type, this.loginData.user_details.provider_id).subscribe(async getCategoriesResponse => {
      this.currentAction = '';

      if (getCategoriesResponse.status === true) { // Success
        this.categories = getCategoriesResponse.categories;
      } else {
        this._utilService.showToast(getCategoriesResponse.message, '', 'error', {});
      }
    }, error2 => { // Error from getCouponTypes
      this.currentAction = '';
    });
  }

  // Add/edit/delete category
  manageCategory() {
    if (!this.categoryName) {
      this._utilService.showToast('Please enter new category name', '', 'warning', {});
    } else {
      this.currentAction = 'manageCategory';

      let manageCategoryBody: any = {
        mode: 'add', 
        name: this.categoryName
      }

      this._couponsService.manageCategory(this.loginData.token, manageCategoryBody).subscribe(async manageCategoryResponse => {
        this.currentAction = '';

        if (manageCategoryResponse.status === true) { // Success
          this._utilService.showToast('New category "' + this.categoryName + '" is added.', '', 'success', {});
          this.actions.emit({ action: 'added' });
        } else {
          this._utilService.showToast(manageCategoryResponse.message, '', 'error', {});
        }
      }, error2 => { // Error from manageCategory
        this.currentAction = '';
      });
    }
  }


}
